import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
import { bulkOrderForm } from '../sections/bulkOrderForm';
import { productGallery } from '../snippets/productGallery';
import { addToCartMessage } from '../snippets/productInfoAddToCartMessage';
import { buyNowPayLater } from '../snippets/productInfoBuyNowPayLater';
import { countdownTimer } from '../snippets/productInfoCountdownTimer';
import { localisedShipping } from '../snippets/productInfoLocalisedShipping';
import { priceAccordion } from '../snippets/productInfoPriceAccordion';
docReady(() => {
    // console.log('Product Template');
    bulkOrderForm();
    productGallery();
    addToCartMessage();
    buyNowPayLater();
    countdownTimer();
    localisedShipping();
    priceAccordion();
});
